import { ICellRendererParams } from 'ag-grid-community';
import { Component } from '@angular/core';
import {
  Task,
  TaskStatusName,
  TaskType,
} from '@compumark/analyst-selection-tool-client';

@Component({
  selector: 'app-results-link-renderer',
  standalone: false,
  templateUrl: './results-link-renderer.component.html',
  styleUrls: ['./results-link-renderer.component.scss'],
})
export class ResultsLinkRendererComponent {
  static readonly resultsDeliveryFailedStatuses = [
    'SEARCH_FAILED',
    'ERROR',
    'RISK_ASSESSMENT_FAILED',
    'ERROR_MAX_GOODS_FRAGMENTS_EXCEEDED',
  ];

  static readonly enabledTaskStatuses = [
    TaskStatusName.WAITING,
    TaskStatusName.BUSY,
    TaskStatusName.FINISHED,
    TaskStatusName.SKIPPED,
    TaskStatusName.PROCESSING_CITES,
  ];

  link!: string;
  task!: Task;

  agInit(params: ICellRendererParams): void {
    this.task = params.data;

    if (this.task.taskType === TaskType.CCLA) {
      this.link = `/canadian-common-law/results-delivery/task/${this.task.id}`;
    } else if (this.task.taskType === TaskType.COPYRIGHT) {
      this.link = `/copyright-and-title/copyright/task/${this.task.id}`;
    } else if (this.task.taskType === TaskType.TITLE) {
      this.link = `/copyright-and-title/title/task/${this.task.id}`;
    } else if (
      this.task.taskType === TaskType.WCL ||
      this.task.taskType === TaskType.WCL_QUALITY
    ) {
      this.link = `/web-common-law/results-delivery/task/${this.task.id}`;
    } else {
      this.link = `/results-overview/results-delivery/${this.task.resultDeliveryId}/task/${this.task.id}/results`;
    }

    this.link += `?order=${this.task.orderId}`;
  }

  isLinkEnabled(): boolean {
    if (!this.task.taskStatus) {
      return false;
    }

    if (
      !this.task.resultDeliveryId &&
      (this.task.taskType === TaskType.SELECTION ||
        this.task.taskType === TaskType.QUALITY)
    ) {
      return false;
    }

    const statusName = this.task.taskStatus?.name;

    const isEnabledTaskStatus =
      (statusName &&
        ResultsLinkRendererComponent.enabledTaskStatuses.includes(
          statusName as
            | 'WAITING'
            | 'BUSY'
            | 'FINISHED'
            | 'SKIPPED'
            | 'PROCESSING_CITES',
        )) ||
      false;

    if (this.task.taskType === TaskType.CCLA) {
      return (
        isEnabledTaskStatus &&
        !!this.task.analystName &&
        this.task.analystName !== 'N/A'
      );
    }

    return (
      isEnabledTaskStatus &&
      (this.task.taskType === TaskType.COPYRIGHT ||
        this.task.taskType === TaskType.TITLE ||
        this.resultsDeliveryIsCompleted())
    );
  }

  public resultsDeliveryFailed(): boolean {
    return ResultsLinkRendererComponent.resultsDeliveryFailedStatuses.includes(
      this.task.resultsDeliveryStatus?.toUpperCase()!,
    );
  }

  private resultsDeliveryIsCompleted(): boolean {
    return (
      !this.resultsDeliveryFailed() &&
      (!this.task.resultsDeliveryStatus ||
        this.task.resultsDeliveryStatus?.toUpperCase() === 'COMPLETED')
    );
  }
}
